import { render } from "./SlideListWrapper.vue?vue&type=template&id=461e522f"
import script from "./SlideListWrapper.vue?vue&type=script&lang=js"
export * from "./SlideListWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__